import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Table} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import ErrorMsg from "../common/ErrorMsg";
import StaffDashboardService from "../../services/StaffDasboardService";


const headingNameList = [
    'first_heading', 'second_heading', 'third_heading', 
    'forth_heading', 'fifth_heading'
];

const EMPTY_DATA = {
    id: 0,
    kpi_list: 0,
    added_on: moment(),
    first_heading: '',
    second_heading: '',
    third_heading: '',
    forth_heading: '',
    fifth_heading: '',
    is_administrative_achievement: true
}

export default class AddAchievementModal extends Component {
    state = {
        headings: [],
        achievementData: {...EMPTY_DATA},
        requiredHeading: '',
        kpiDefinition: '',
        isLoading: false
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        try {
            if (!(isEmpty(this.props.selectedKPI))) {
                let achievementData = this.state.achievementData;
                achievementData['kpi_list'] = this.props.selectedKPI.kpi_list_id;
                let result = await StaffDashboardService.getKPIHeadings(this.props.selectedKPI.kpi_list_id);

                let headings = [];
                if (200 === result.status) {
                    headings = result.data.kpi_headings.map((heading, index) => {
                        let mHeading = {...heading};
                        if (mHeading.has_property && index < 5) {
                            this.setState({requiredHeading: headingNameList[index]});
                        }
                        return mHeading;
                    });
                    this.setState({headings, achievementData});
                }
            }
        } catch (error) {
            console.log(error);
        }
        try {
            let result = await StaffDashboardService.getKPIDetails(this.props.selectedKPI.kpi_list_id);

            if (200 === result.status) {
                let kpiDefinition = result.data.definition;
                this.setState({kpiDefinition});
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    };

    toggleModal = () => {
        let achievementData = {...EMPTY_DATA};
        this.setState({
            headings: [],
            achievementData, 
            requiredHeading: 'second_heading'
        }, () => this.props.toggleModal());
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let achievementData = {...this.state.achievementData};
        achievementData[name] = value;
        this.setState({achievementData});
    };

    handleFormattedData = (name, value) => {
        let achievementData = {...this.state.achievementData};
        achievementData[name] = value;
        this.setState({achievementData});
    };

    submitAchievement = async (wantToClose) => {
        let achievementData = {...this.state.achievementData};
        achievementData['added_on'] = moment(achievementData.added_on).format("YYYY-MM-DD");
        let {requiredHeading} = this.state;
        if (requiredHeading) {
            if (achievementData[requiredHeading]) {
                let numberValue = String(achievementData[requiredHeading]).replace(/,|\$| /g, '');
                achievementData[requiredHeading] = numberValue;
                if (isNaN(numberValue)) {
                    toast.error(requiredHeading + " accepts only number (Integer/Float greater than 0).");
                    return false;
                }
            } else {
                toast.error(requiredHeading + " is required field and it accepts only number (Integer/Float greater than 0).");
                return false;
            }
        }
        this.setState({isLoading: true});
        try {
            const result = await StaffDashboardService.postAchievement(achievementData);
            if (201 === result.status) {
                let requiredHeadingData = 0;
                if (requiredHeading) {
                    requiredHeadingData = achievementData[requiredHeading];
                }
                let newAchievementData = {
                    ...EMPTY_DATA,
                    kpi_list: achievementData.kpi_list
                }
                this.setState({
                    achievementData: newAchievementData,
                    requiredHeading: wantToClose ? '' : requiredHeading,
                    isLoading: false
                });
                toast.success("Added Successfully.");
                this.props.updateAchievement(
                    result.data.achievement, requiredHeadingData, wantToClose, true
                );
                return true;
            }
            return false;
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
        this.setState({isLoading: false});
        return false;
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date) => {
        let achievementData = {...this.state.achievementData};
        achievementData['added_on'] = date;
        this.setState({achievementData});
    };

    render() {
        const {headings, achievementData, kpiDefinition, isLoading} = this.state;
        const {selectedKPI} = this.props;
        let headingList = [], fieldList = [];
        headings.map((heading, index) => {
            let heading_name = '';
            if (index < 5) {
                heading_name = headingNameList[index];
            } 
            headingList.push( 
                <th key={index} className="border-0 font-weight-bold align-bottom text-center">
                    {heading.heading} {heading.has_property ?<span className="text-red" title="Required Field">*</span>: null}
                </th>
            );
            fieldList.push(
                <td key={index} className="border-0 text-center">
                { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                    <select name={heading_name} className="form-control text-center" 
                        onChange={this.handleChange} 
                        value={achievementData[heading_name]}
                    >
                        <option key={0} value={''}>---Select---</option>
                        {heading.drop_down_items.map((item, ind) => {
                            return (<option key={ind} value={item.item}>{item.item}</option>);
                        })}
                    </select>
                    : heading.has_property ? 
                        selectedKPI.data_type === "Currency" ?
                            <NumberFormat type="tel" 
                                value={achievementData[heading_name]} 
                                thousandSeparator={true} prefix={'$ '}  
                                decimalScale={2} allowNegative={false} 
                                onValueChange={(values) => this.handleFormattedData(
                                    heading_name, values.floatValue
                                )} className="form-control text-center " 
                                name={heading_name} 
                            />
                            : selectedKPI.data_type === "Percentage" ?
                                <NumberFormat type="tel" 
                                    value={achievementData[heading_name]} 
                                    thousandSeparator={true} suffix={' %'}  
                                    decimalScale={2} allowNegative={false} 
                                    onValueChange={(values) => this.handleFormattedData(
                                        heading_name, values.floatValue
                                    )} className="form-control text-center " 
                                    name={heading_name} 
                                />
                                :
                                <NumberFormat type="tel" 
                                    value={achievementData[heading_name]} 
                                    thousandSeparator={true} decimalScale={0}
                                    allowNegative={false} 
                                    onValueChange={(values) => this.handleFormattedData(
                                        heading_name, values.floatValue
                                    )} className="form-control text-center " 
                                    name={heading_name} 
                                />
                        :
                        <input name={heading_name} type="text" 
                            className="form-control text-center" 
                            onChange={this.handleChange} 
                            value={achievementData[heading_name]} 
                        />
                }
                </td>
            );
        });
        
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="xl">
                <ModalHeader toggle={this.toggleModal}>
                    Add Achievement for KPI `{selectedKPI.kpi_name}`
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <Input type="textarea" className="form-control" 
                            name="definition" rows="3" value={kpiDefinition} 
                            disabled={true} 
                        />
                    </div>
                    <Table responsive size="sm">
                        <thead>
                            <tr>
                                <th className="border-0 font-weight-bold align-bottom 
                                    text-center" style={{ width:"120px" }}
                                >Date</th>
                                {headingList}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-0">
                                    <div className="div-datepicker">
                                        <DatePicker
                                            selected={achievementData.added_on}
                                            onChangeRaw={this.handleDateChangeRaw}
                                            onChange={(event) => this.handleDateChange(event)}
                                            dateFormat="MM/DD/YYYY"
                                            fixedHeight
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className="form-control text-center"
                                            minDate={moment(this.props.periodStartDate)}
                                            maxDate={moment()}
                                            autoComplete="off"
                                        />
                                    </div>
                                </td>
                                {fieldList}
                            </tr>
                        </tbody>
                    </Table>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-success' 
                        onClick={() => this.submitAchievement(false)}
                        disabled={isLoading}
                    >Save</Button>
                    <Button className='btn btn-success' 
                        onClick={() => this.submitAchievement(true)}
                        disabled={isLoading}
                    >Save & Close</Button>
                    <Button className='btn btn-secondary' 
                        onClick={this.toggleModal}
                    >Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/staffDashboard/AddAchievementModal.js